import React, { useEffect, useCallback, useRef, useState } from 'react';
import { DocumentUiProps, HTMLDocumentUiElement } from '@innovatrics/dot-auto-capture-ui/document';
import {
  dispatchControlEvent,
  DocumentCustomEvent,
  ControlEventInstruction
} from '@innovatrics/dot-document-auto-capture/events';

import '@innovatrics/dot-document-auto-capture';
import '@innovatrics/dot-auto-capture-ui/document';
import { Box, Button, ButtonGroup, Grid, IconButton, Stack, Typography } from '@mui/material';
// import styles from './styles/index.module.css';
import { useNavigate } from 'react-router';
import { MdOutlineClose } from 'react-icons/md';
import { userDataFromLocal } from '../utils/getUserDetails';
import PageHeading from '../../global/header/PageHeading';
import { Cameraswitch } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const DocumentCamera = (props) => {
  useEffect(() => {
    const documentAutoCaptureHTMLElement = document.getElementById('x-dot-document-auto-capture');

    if (documentAutoCaptureHTMLElement) {
      documentAutoCaptureHTMLElement.props = props;
      documentAutoCaptureHTMLElement.cameraOptions = props;
    }
  }, [props]);

  return <x-dot-document-auto-capture id="x-dot-document-auto-capture" />;
};

function WebcamCaptureDocFront({
  documentCameraRef,
  setImageSrc,
  setShowFrontCamera,
  iconButtonHandler,
  fileMode,
  heading
  // fireOcrApi
}) {
  const cameraSoundRef = useRef(null);
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const docName = urlParams.get('document_name');
  const ocrType = urlParams.get('ocrType');

  function cropAndCreateFile(blob, cropX, cropY, cropWidth, cropHeight) {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Set canvas dimensions to cropped size
        canvas.width = cropWidth;
        canvas.height = cropHeight;

        // Draw the cropped portion onto the canvas
        ctx.drawImage(img, cropX, cropY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

        // Convert the canvas content to a blob
        canvas.toBlob(
          (blobResult) => {
            // Create a File object from the blob
            const file = new File([blobResult], 'cropped_image.png', {
              type: 'image/png',
              lastModified: Date.now()
            });

            resolve(blobResult);
          },
          'image/png', // Specify the output format
          1.0 // Image quality (ignored for PNG)
        );
      };

      img.onerror = function (error) {
        reject(error);
      };

      // Set the source of the image to the input blob
      img.src = URL.createObjectURL(blob);
    });
  }

  const handleDocumentPhotoTaken = async ({ image, data }, content) => {
    console.log('imgData', content);
    console.log('imgData', data);
    console.log('imgData', image);

    let cropX = 250;
    let cropY = 100;
    let cropWidth = 790;
    let cropHeight = 540;

    if (window.screen.width < 900) {
      cropX = 40;
      cropY = 560;
      cropWidth = 1000;
      cropHeight = 750;
    }

    if (image) {
      const newImageFile = await cropAndCreateFile(image, cropX, cropY, cropWidth, cropHeight)
        .then((croppedFile) => {
          // Now you can post the croppedFile to the server or perform any other actions
          console.log('Cropped file:', croppedFile);
          return croppedFile;
        })
        .catch((error) => {
          console.error('Error cropping and creating file:', error);
        });
      const imageUrl = URL.createObjectURL(newImageFile);

      console.log('imageUrl', imageUrl);

      const urlParams = new URLSearchParams(window.location.search);
      const docCode = urlParams.get('document_code');
      //  `DocWithWatermark_${docCode}_${sideAngle}.jpg`
      // const docNameReadable = docName.replace(/ /g, '_').toLowerCase();
      // const file = new File([image], `${docNameReadable}_${fileMode}.jpg`, {
      const file = new File([newImageFile], `_${docCode}_${fileMode}.jpg`, {
        type: newImageFile.type,
        lastModified: new Date().getTime()
      });

      // blob to base 64 image
      // const reader = new FileReader();
      // reader.onload = (event) => {
      //   const dataURL = event.target.result;
      //   // console.log('dataURL', dataURL);
      //   setImageSrc(dataURL);
      // };
      // reader.readAsDataURL(imageBlob);
      setImageSrc({ img: imageUrl, file: file });
    }

    if (cameraSoundRef.current) {
      cameraSoundRef.current.play(); // camera sound, when clicked image
      setTimeout(() => {
        setShowFrontCamera(false);
      }, 1000);
    }

    // fireOcrApi(imageUrl);
  };

  const handleError = useCallback((error) => {
    alert(error);
  }, []);

  const DocumentUi = (props) => {
    useEffect(() => {
      const uiElement = document.getElementById('x-dot-document-auto-capture-ui');

      const styleNode = document.createElement('div');

      uiElement?.shadowRoot?.append(styleNode);

      if (uiElement) {
        uiElement.props = {
          ...props,
          styleTarget: styleNode
        };
      }
    });

    return <x-dot-document-auto-capture-ui id="x-dot-document-auto-capture-ui" />;
  };

  // file or browse file from system
  const handleFileUpload = (e) => {
    const file = e.target.files[0]; // blob file use to make base64 image
    const blobSimple = e.target.files[0]; // blob file use directly to rename blob
    if (file || blobSimple) {
      // modified new file structure with the name
      // const docNameReadable = docName.replace(/ /g, '_').toLowerCase();
      // const ImageFile = new File([blobSimple], `${docNameReadable}_${fileMode}.jpg`, {
      const ImageFile = new File([blobSimple], `_${fileMode}.jpg`, {
        type: blobSimple.type,
        lastModified: new Date().getTime()
      });
      // modified new file structure with the name end
      // convert into base64
      const reader = new FileReader();
      reader.onloadend = () => {
        // console.log('handleFileUpload', { img: reader.result, file: ImageFile });
        setImageSrc({ img: reader.result, file: ImageFile });
      };
      reader.readAsDataURL(file);
    }

    setTimeout(() => {
      setShowFrontCamera(false);
    }, 500);
  };

  // const imageUrl = URL.createObjectURL(image);
  // if (image) {
  //   const docNameReadable = docName.replace(/ /g, '_').toLowerCase();
  //   const file = new File([image], `${docNameReadable}_${fileMode}.jpg`, {
  //     type: image.type,
  //     lastModified: new Date().getTime()
  //   });

  //   setImageSrc({ img: imageUrl, file: file });
  // }

  let setHeiWdt = {};
  if (window.screen.width < 900) {
    setHeiWdt = { imageResolution: { width: 360, height: 270 } };
  }

  const switchCamera = () => {
    dispatchControlEvent(DocumentCustomEvent.CONTROL, ControlEventInstruction.SWITCH_CAMERA);
  };

  const toggleMirror = () => {
    dispatchControlEvent(DocumentCustomEvent.CONTROL, ControlEventInstruction.TOGGLE_MIRROR);
  };
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="95vh"
        className="containerStyle"
      >
        <Box className="cameraHeading">
          {fileMode === 'front' ? `${t(heading)} - ${t('Front')}` : `${t(heading)} - ${t('Back')}`}
        </Box>
        <IconButton
          size="small"
          className="closeMarkStyle"
          onClick={(e) => {
            iconButtonHandler(e);
          }}
        >
          <MdOutlineClose size={24} />
        </IconButton>

        <ButtonGroup size="small" className="cameraSwitchBtn">
          <Button onClick={switchCamera}>
            <Cameraswitch className="cameraSwitch" />
          </Button>
          <Button onClick={toggleMirror}>
            <svg
              fill="none"
              height="40"
              viewBox="0 0 52 52"
              width="40"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 26C0 11.6406 11.6406 0 26 0C40.3594 0 52 11.6406 52 26C52 40.3594 40.3594 52 26 52C11.6406 52 0 40.3594 0 26Z"
                fill="#131313"
                fill-opacity="0.3"
              ></path>
              <circle cx="17.5" cy="24.5" fill="white" r="1.5"></circle>
              <path
                d="M15 17H16C19.5 17 23 21 23 29C22.5 29 21.5 29 20 29C20 29 20.25 33 19.5 34.5C18.75 36 16 36 16 36H15"
                stroke="white"
                stroke-width="2"
              ></path>
              <circle fill="white" r="1.5" transform="matrix(-1 0 0 1 34.5 24.5)"></circle>
              <path
                d="M37 17H36C32.5 17 29 21 29 29C29.5 29 30.5 29 32 29C32 29 31.75 33 32.5 34.5C33.25 36 36 36 36 36H37"
                stroke="white"
                stroke-width="2"
              ></path>
            </svg>
          </Button>
        </ButtonGroup>

        <Grid container md={7} sm={7} xs={12} className="docCameraHolder">
          <Grid
            item
            sx={{
              position: 'relative',
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center'
            }}
            className="documentCaptureBox"
            label={JSON.stringify(setHeiWdt)}
          >
            <DocumentCamera
              className="documentCaptureCameraMain"
              cameraFacing={window.screen.width < 1000 ? 'environment' : 'user'}
              onPhotoTaken={handleDocumentPhotoTaken}
              onError={handleError}
              ref={documentCameraRef}
              resolution="high"
              captureQuality="high"
              // samWasmUrl="/wasm/sam.wasm"
              imageResolution={{
                height: '270px',
                width: '360px'
              }}
            />
            <DocumentUi showCameraButtons />
          </Grid>
        </Grid>
        {ocrType === 'NonOcr' ? (
          <Box
            className="uploadFile"
            style={{ position: 'absolute', top: '10px', textAlign: 'center' }}
          >
            <Stack mb={1} style={{ textAlign: 'center' }}>
              <input
                accept="image/png, image/jpg, image/jpeg"
                className="fileInput mainBtn"
                id="contained-button-file1"
                type="file"
                onChange={(e) => handleFileUpload(e)}
              />
            </Stack>
            <Typography variant="h7" style={{ textAlign: 'center', display: 'block' }}>
              OR
            </Typography>
          </Box>
        ) : (
          ''
        )}
      </Box>
      {/* <Box className="cameraSound" style={{ opacity: 0, position: 'absolute' }}> */}
      <Box className="cameraSound" style={{ opacity: 0 }}>
        <audio controls ref={cameraSoundRef}>
          <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.mp3`} type="audio/mp3" />
          <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.mp3`} type="audio/mp3" />
          <source src={`${BASE_URL}/assets/iphone-camera-capture-6448.ogg`} type="audio/ogg" />
          Your browser does not support the audio element.
        </audio>
      </Box>
    </>
  );
}

export default WebcamCaptureDocFront;
